module.exports = __webpack_public_path__ + "static/img/service3.55a16ad2.png";